import React from "react";

export const writingPreviewMarkdownComponents = {
	p: ({ children }) => <p className="writing-preview__md-p">{children}</p>,
	h1: ({ children }) => <h1 className="writing-preview__md-h1">{children}</h1>,
	h2: ({ children }) => <h2 className="writing-preview__md-h2">{children}</h2>,
	h3: ({ children }) => <h3 className="writing-preview__md-h3">{children}</h3>,
	h4: ({ children }) => <h4 className="writing-preview__md-h4">{children}</h4>,
	strong: ({ children }) => <strong className="writing-preview__md-strong">{children}</strong>,
	ul: ({ children }) => <ul className="writing-preview__md-ul">{children}</ul>,
	li: ({ children }) => <li className="writing-preview__md-li">{children}</li>,
};
